var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebcameraWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53099 8C8.43119 8 9.16094 7.28366 9.16094 6.4C9.16094 5.51634 8.43119 4.8 7.53099 4.8C6.6308 4.8 5.90104 5.51634 5.90104 6.4C5.90104 7.28366 6.6308 8 7.53099 8Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53099 0C3.94511 0 1.0112 2.88 1.0112 6.4C1.0112 9.92 3.94511 12.8 7.53099 12.8C11.1169 12.8 14.0508 9.92 14.0508 6.4C14.0508 2.88 11.1169 0 7.53099 0ZM7.53099 0.8C7.93848 0.8 8.34596 1.2 8.34596 1.6C8.34596 2 7.93848 2.4 7.53099 2.4C7.04201 2.4 6.71602 2.08 6.71602 1.6C6.71602 1.12 7.04201 0.8 7.53099 0.8ZM7.53099 9.6C5.73805 9.6 4.2711 8.16 4.2711 6.4C4.2711 4.64 5.73805 3.2 7.53099 3.2C9.32393 3.2 10.7909 4.64 10.7909 6.4C10.7909 8.16 9.32393 9.6 7.53099 9.6Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2138 16H0.848209C0.19623 16 -0.211257 15.28 0.114733 14.8L1.74468 12.08C3.21163 13.52 5.24906 14.4 7.44949 14.4C9.64992 14.4 11.6874 13.52 13.1543 12.08L14.7843 14.8C15.2732 15.28 14.8658 16 14.2138 16Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcameraWhite);
export default __webpack_public_path__ + "static/media/webcamera-white.09e67d85b474328b71c9ba0c73af559c.svg";
export { ForwardRef as ReactComponent };